import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Test } from '../../../data/models/test/test';
import { TestExecution } from '../../../data/models/execution/test-execution';
import { MeService } from '../../../services/api/me.service';

@Component({
  selector: 'app-test-execution-start',
  templateUrl: './test-execution-start.component.html',
  styleUrls: ['./test-execution-start.component.css']
})
export class TestExecutionStartComponent implements OnInit {

  @Input() urlCode?: string;
  @Input() test!: Test;
  @Input() unfinishedExecution: TestExecution | null = null;
  @Input() finishedExecution: TestExecution | null = null;

  @Output() startExecution = new EventEmitter<TestExecution>();

  constructor(public meService: MeService) {}

  ngOnInit(): void {}

  onExecutionStart(execution: TestExecution): void {
    this.startExecution.emit(execution);
  }

  startAnonymousTest(): void {
    if (!this.urlCode) {
      console.error('urlCode is missing');
      return;
    }else console.log(this.urlCode)
    this.meService.startAnonymousTest(this.test.id, this.urlCode)
      .then(execution => {
        this.startExecution.emit(execution);
      })
      .catch(error => {
        console.error('Failed to start anonymous test:', error);
      });
  }
}